<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <router-link to="/" class="logo">
          <img :src="logoImg" alt="대상 웰라움 순창" class="logo-img" />
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import logoImg from '@/assets/logo/logo.png'

export default {
  name: 'MobileHeader',
  data() {
    return {
      logoImg
    }
  }
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: var(--primary, #16294F);
  transition: background 0.3s ease;
}

.header-inner {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 56px;
  width: auto;
  display: block;
  /* 로고 흰색 맵핑 (진녹색 헤더 위) */
  filter: brightness(0) invert(1);
}
</style>
